import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { useQuery, useQueryClient } from "react-query";
import useLocalStorage from "react-use-localstorage";
import { FormattedMessage } from "react-intl";
import { useParams } from "react-router-dom";

import Schedule from "./schedule";
import { ScheduleEndpointResponseObject } from "../types/presentation";

const MyPresentations: React.FC<{
  locale: string;
  setLocale: any;
}> = ({ locale, setLocale }) => {
  const { event_slug, presentation_slug } = useParams<{
    event_slug: string;
    presentation_slug: string;
  }>();

   console.log("event_slug", event_slug);
  // const intl = useIntl();
  const queryClient = useQueryClient();
  const [fetchData, setFetchData] = useState(false);
  // const slug = new URLSearchParams(document.location.search).get('event') || "invalid";
  const [eventPassword] = useLocalStorage(event_slug, "");

  const { data, isLoading, error } = useQuery(
    "event",
    async () => {
      const url =
        process.env.REACT_APP_API_ENDPOINT +
        "/api/public/schedule/" +
        event_slug;
       console.log("url in my presentation  ", url);

      const response = await axios.get<ScheduleEndpointResponseObject>(
        url,

        {
          params: { password: eventPassword },
        }
      );
      return response.data;
    },
    {
      enabled: fetchData,
      onSuccess: (resp) => {
        const { event } = resp.data;
        resp.data.presentations.forEach((presentation) => {
          queryClient.setQueryData(["presentation", presentation._id], () => ({
            statusCode: 201,
            message: "event.fetch-success",
            data: { event, presentation },
          }));
        });
      },
    }
  );

  useEffect(() => {
    //  console.log('debug: ', data, presentation_id);
    if (!data) {
      //  console.log('debug: fetchData')
      setFetchData(true);
    }
  }, [setFetchData, data]);

  if (error || !data) return <div></div>;

  const { data: eventData } = data;
  return (
    <div className="home-container-with-login my-presentation-container">
      {/* { console.log(
        "in my presentation page -----------------------------------------------------------------------------------------------",
        eventData
      )} */}
      <Schedule
        locale={locale}
        setLocale={setLocale}
        isSpeaker={true}
        eventData={eventData}
        setSchedule={"my-pres"}
      />
    </div>
  );
};

export default MyPresentations;
